import React from "react";
import PropTypes from "prop-types";
import ButtonIconText from "components/molecules/ButtonIconText";
import classNames from "classnames";

const DropDownButton = ({
  name,
  value,
  onClick,
  refParent,
  caption,
  hasSelectedValue,
  className,
  dropdownActive = false,
  disabled,
  ...rest
}) => {
  const iconLeft = false;

  const baseClassName = "sal-dropdown-button";
  const status = dropdownActive ? "open" : "close";
  const componentClassName = classNames(
    baseClassName,
    `${baseClassName}--${status}`,
    className,
    {
      [`${baseClassName}--selected`]: hasSelectedValue,
      [`${baseClassName}--disabled`]: disabled,
    },
  );

  return (
    <ButtonIconText
      disabled={disabled}
      name={name}
      onClick={onClick}
      text={caption}
      iconType="Dropdown_close"
      iconLeft={iconLeft}
      className={componentClassName}
      value={value}
      type="button"
      refParent={refParent}
      styleType="secondary"
      title={caption}
      {...rest}
    />
  );
};

DropDownButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  refParent: PropTypes.func,
  caption: PropTypes.string.isRequired,
  hasSelectedValue: PropTypes.bool,
  className: PropTypes.string.isRequired,
  dropdownActive: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default DropDownButton;
